import './plugins/swiper/swiper.min.css';
import 'viewerjs/dist/viewer.css';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index.js';
import ScreenVideo from './components/screen_video/screen_video.vue';
import DragVideo from './components/drag_video/drag_video.vue';
import Loading from './components/loading/loading.vue';
import NetworkErr from './components/network_err/network_err.vue';
import Empty from './components/empty/empty.vue';
import Swiper from './plugins/swiper/swiper.min.js';
import swal from 'sweetalert';
import Viewer from 'v-viewer';

Vue.config.productionTip = false;

Vue.prototype.Swiper = Swiper;
Vue.prototype.phoneReg = /^1[3456789]\d{9}$/;

// 11234
Vue.component('ScreenVideo', ScreenVideo);
Vue.component('DragVideo', DragVideo);
Vue.component('Loading', Loading);
Vue.component('NetworkErr', NetworkErr);
Vue.component('Empty', Empty);

Vue.prototype.swal = swal;

Vue.use(Viewer, {
		defaultOptions: {
			toolbar: false,
			title: false,
			navbar: false
		}
	}
);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
